// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__rdeij","rootCenter":"LoadMoreObserver_rootCenter__1k3Wp","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1qNK0"};